import { IMAGES } from "./images";

export interface ServiceItem {
  slug: string;
  title: string;
  icon: string;
  emoji: string;
  price: string;
  priceLabel: string;
  shortDesc: string;
  description: string;
  features: string[];
  imageSrc: string;
  route: string;
  color: string;
}

export const SERVICES: ServiceItem[] = [
  {
    slug: "avi",
    title: "Attestation AVI",
    icon: "certificate",
    emoji: "📜",
    price: "",
    priceLabel: "",
    shortDesc:
      "Obtenez votre AVI certifiée en 48h pour votre dossier Campus France.",
    description:
      "L'Attestation de Virement Irrévocable est obligatoire pour les études en France et Belgique. Délivrée en 48h, certifiée et reconnue par les consulats.",
    features: [
      "Traitement prioritaire en 48h",
      "Document 100% certifié",
      "PDF téléchargeable immédiatement",
      "Valable pour Campus France",
      "Support inclus 7j/7",
      "Vérification en ligne",
    ],
    imageSrc: IMAGES.travelImg,
    route: "/services/avi",
    color: "#4F46E5",
  },
  {
    slug: "visa",
    title: "Accompagnement Visa",
    icon: "passport",
    emoji: "🛂",
    price: "500€",
    priceLabel: "forfait complet",
    shortDesc:
      "Constitution de dossier, préparation entretien, suivi jusqu'à l'obtention.",
    description:
      "Notre équipe vous accompagne de A à Z dans la constitution de votre dossier de visa étudiant et la préparation à l'entretien consulaire.",
    features: [
      "Analyse complète du dossier",
      "Liste personnalisée des pièces",
      "Simulation entretien consulaire",
      "Suivi en temps réel",
      "Relances consulaires",
      "Garantie satisfaction",
    ],
    imageSrc: IMAGES.confianceImg,
    route: "/services/visa",
    color: "#059669",
  },
  {
    slug: "logement",
    title: "Logement Étudiant",
    icon: "home",
    emoji: "🏠",
    price: "À partir de 100€",
    priceLabel: "",
    shortDesc:
      "Résidence garantie avant votre départ, sécurisée et proche de votre université.",
    description:
      "Nous réservons pour vous un logement étudiant sécurisé à proximité de votre université. Résidences CROUS, colocations ou studios.",
    features: [
      "Résidence réservée avant départ",
      "Logements proches universités",
      "Contrat de bail vérifié",
      "Visite virtuelle disponible",
      "Accompagnement emménagement",
      "Garantie placement",
    ],
    imageSrc:
      "https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=768&q=80",
    route: "/services/logement",
    color: "#D97706",
  },
  {
    slug: "billets",
    title: "Billets d'Avion",
    icon: "plane",
    emoji: "✈️",
    price: "",
    priceLabel: "",
    shortDesc:
      "Meilleurs tarifs garantis, dates flexibles, bagages étudiants inclus.",
    description:
      "Nous négocions les meilleurs tarifs aériens pour les étudiants avec des dates flexibles et des bagages supplémentaires inclus.",
    features: [
      "Tarifs étudiants négociés",
      "Dates flexibles",
      "Bagages supplémentaires",
      "Comparaison toutes compagnies",
      "Assurance annulation",
      "Assistance aéroport",
    ],
    imageSrc: IMAGES.destinationImg,
    route: "/services/billets",
    color: "#2563EB",
  },
  {
    slug: "finances",
    title: "Support Financier",
    icon: "wallet",
    emoji: "💳",
    price: "100€",
    priceLabel: "frais de montage",
    shortDesc:
      "Aide au montage de dossier de bourse, ouverture compte bancaire à distance.",
    description:
      "Nous vous aidons à constituer votre dossier de bourse et à ouvrir votre compte bancaire à distance avant votre départ.",
    features: [
      "Dossier bourse Campus France",
      "Ouverture compte à distance",
      "Identification aides CAF",
      "Conseils budget étudiant",
      "Simulation coûts vie",
      "Accompagnement allocations",
    ],
    imageSrc:
      "https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=768&q=80",
    route: "/services/finances",
    color: "#7C3AED",
  },
  {
    slug: "support",
    title: "Support 24/7",
    icon: "headset",
    emoji: "🎧",
    price: "100€",
    priceLabel: "par mois",
    shortDesc:
      "Un conseiller dédié disponible à tout moment pour répondre à vos questions.",
    description:
      "Avec notre service de support premium, un conseiller dédié vous accompagne à chaque étape de votre intégration.",
    features: [
      "Conseiller dédié personnel",
      "WhatsApp / Email / Appel",
      "Réponse < 1h garantie",
      "Suivi post-arrivée 6 mois",
      "Réseau anciens étudiants",
      "Aide démarches administratives",
    ],
    imageSrc: IMAGES.contactImg,
    route: "/services/support",
    color: "#DC2626",
  },
];

export interface DestinationItem {
  code: string;
  name: string;
  flag: string;
  tagline: string;
  description: string;
  processingTime: string;
  averageCost: string;
  universities: string[];
  requirements: string[];
  imageSrc: string;
  route: string;
}

export const DESTINATIONS: DestinationItem[] = [
  {
    code: "FR",
    name: "France",
    flag: "🇫🇷",
    tagline: "La destination phare des étudiants africains",
    description:
      "La France accueille plus de 350 000 étudiants internationaux par an. Enseignement de qualité mondiale, campus dynamiques et culture riche.",
    processingTime: "4 à 8 semaines",
    averageCost: "800 – 1 200€ / mois",
    universities: ["Sorbonne", "Paris Saclay", "Montpellier", "Bordeaux"],
    requirements: [
      "AVI Campus France",
      "Visa étudiant (VLS-TS)",
      "Assurance maladie",
      "Preuve logement",
    ],
    imageSrc: IMAGES.franceImg,
    route: "/destinations/france",
  },
  {
    code: "BE",
    name: "Belgique",
    flag: "🇧🇪",
    tagline: "Excellence académique au cœur de l'Europe",
    description:
      "La Belgique offre un enseignement supérieur de réputation internationale avec des frais parmi les plus bas d'Europe.",
    processingTime: "3 à 6 semaines",
    averageCost: "700 – 1 000€ / mois",
    universities: ["UCLouvain", "ULB", "KU Leuven", "UGent", "Liège"],
    requirements: [
      "Autorisation de séjour",
      "Preuve inscription",
      "Ressources financières",
      "Assurance",
    ],
    imageSrc: IMAGES.belgiqueImg,
    route: "/destinations/belgique",
  },
  {
    code: "CA",
    name: "Canada",
    flag: "🇨🇦",
    tagline: "Immigration simplifiée, avenir garanti",
    description:
      "Le Canada offre une voie directe vers la résidence permanente. Université de renom, marché du travail dynamique.",
    processingTime: "8 à 16 semaines",
    averageCost: "1 200 – 2 000€ / mois",
    universities: ["McGill", "Toronto", "UBC", "Waterloo", "Montréal"],
    requirements: [
      "Permis d'études",
      "CAQ (Québec)",
      "Preuve financière",
      "Lettre acceptation",
    ],
    imageSrc: IMAGES.canadaImg,
    route: "/destinations/canada",
  },
  {
    code: "LU",
    name: "Luxembourg",
    flag: "🇱🇺",
    tagline: "Trilinguisme et opportunités uniques",
    description:
      "Le Luxembourg, pays trilingue au cœur de l'Europe, propose une Université internationale avec des perspectives professionnelles excellentes.",
    processingTime: "4 à 8 semaines",
    averageCost: "1 000 – 1 500€ / mois",
    universities: ["Université du Luxembourg"],
    requirements: [
      "Visa type D",
      "Autorisation séjour",
      "Preuve financière",
      "Assurance maladie",
    ],
    imageSrc: IMAGES.luxembourgImg,
    route: "/destinations/luxembourg",
  },
];

export const STATS = [
  { value: "250+", label: "Étudiants accompagnés" },
  { value: "98%", label: "Taux de satisfaction" },
  { value: "48h", label: "Délai AVI moyen" },
  { value: "4", label: "Pays desservis" },
];
